import { Directive, ElementRef, AfterViewChecked, Input } from '@angular/core';

@Directive({
    selector: '[appFixedAspect]'
})
export class FixedAspectDirective implements AfterViewChecked {
    constructor(private el: ElementRef) { }

    // region IO Properties
    @Input() aspectRatio: number;
    // endregion

    // region Lifecycle Hooks

    ngAfterViewChecked(): void {
        this.el.nativeElement.style.minHeight = this.el.nativeElement.clientWidth / this.aspectRatio + 'px';
    }

    // endregion
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/fixed-aspect.directive.ts